function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.014.559a2 2 0 011.972 0l4.234 2.4 4.195 2.466a2 2 0 01.986 1.709L22.44 12l-.039 4.866a2 2 0 01-.986 1.709L17.22 21.04l-4.234 2.4a2 2 0 01-1.972 0l-4.234-2.4-4.195-2.466a2 2 0 01-.986-1.709L1.56 12l.039-4.866a2 2 0 01.986-1.709L6.78 2.96l4.234-2.4z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.293 7H9.707A2.71 2.71 0 007 9.707v4.586A2.71 2.71 0 009.707 17h4.586A2.71 2.71 0 0017 14.293V9.707A2.71 2.71 0 0014.293 7zM12 14.734A2.737 2.737 0 019.266 12 2.737 2.737 0 0112 9.266 2.737 2.737 0 0114.734 12 2.737 2.737 0 0112 14.734zm2.8-4.823a.809.809 0 11.001-1.618.809.809 0 01-.001 1.618z",
  fill: "#1976D2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 9.852A2.15 2.15 0 009.852 12 2.15 2.15 0 0012 14.148 2.15 2.15 0 0014.148 12 2.15 2.15 0 0012 9.852zM14.8 8.88a.222.222 0 100 .445.222.222 0 000-.444z",
  fill: "#1976D2"
});

function SvgSocialInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgSocialInstagram;